module.exports = __webpack_public_path__ + "media/mypage/images/special/001-a986c4b975f9eafc9b6c25e844ddefcb.jpg";